export const payoutSettlementValidation = initialForm => {
  const { settlementDate, settlementStatus } = initialForm;

  const otherAdjustmentMessage = () => null;
  const paymentFeeAdjustmentMessage = () => null;
  const paymentFeeAdjustmentVatMessage = () => null;

  const settlementDateMessage = () => {
    if (settlementDate === null || settlementDate === "") {
      return "This field is required";
    }
    return null;
  };
  const settlementStatusMessage = () => {
    if (settlementStatus === null || settlementStatus === "") {
      return "This field is required";
    }
    return null;
  };

  return {
    otherAdjustment: otherAdjustmentMessage(),
    paymentFeeAdjustment: paymentFeeAdjustmentMessage(),
    paymentFeeAdjustmentVat: paymentFeeAdjustmentVatMessage(),
    settlementDate: settlementDateMessage(),
    settlementStatus: settlementStatusMessage()
  };
};

export const payableStatusValidation = initialForm => {
  const { payableStatus } = initialForm;

  const payableStatusMessage = () => {
    if (payableStatus === null || payableStatus === "") {
      return "This field is required";
    }
    return null;
  };

  return {
    payableStatus: payableStatusMessage()
  };
};
export const hasNoError = validationError => {
  let thisReturn = true;
  Object.keys(validationError).forEach(key => {
    if (thisReturn) {
      thisReturn = validationError[key] === null;
    }
  });
  return thisReturn;
};
